import {Gender, ValidityFormValues} from "./ValidityForm";
import SimpleIndicator, {SimpleIndicatorStyle} from "../../designSystem/SimpleIndicator";
import React from "react";

export interface ValidityformRecapProps {
    validityFormValues: ValidityFormValues;
    modify?: () => void;
}

const ValidityformRecap = (props: ValidityformRecapProps) => {
    const { firstName, lastName, birthDate, gender } = props.validityFormValues;
    return (
        <div className={"flex"}>
            <SimpleIndicator
                title={"Pratiquant(e)"}
                // @ts-ignore
                value={`${firstName} ${lastName}, né(e) le ${!!birthDate && birthDate.toLocaleDateString()}, ${Gender[gender]}`}
                style={SimpleIndicatorStyle.INLINE}
            />
            {props.modify && <div
                className={"flex justify-center text-blue cursor-pointer ml-4"}
                onClick={props.modify}
            >
                Modifier
            </div>}
        </div>
    );
}

export default  ValidityformRecap;